import {
    SUMMARYLIST_REQUEST,
    SUMMARYLIST_ERROR,
    SUMMARYLIST_SUCCESS,
    SUMMARYLIST_params
} from "../actions/summaryList";
import apiCalls from "utils/api";
import store from '../../store';
import Vue from "vue";

const state = {
    summaryList: [],
    summaryListStatus: "",
};

const getters = {
    getSummaryList: state => state.summaryList,
    isSummaryListLoaded: state => !!state.summaryList,
    getSummaryListStatus: state => state.summaryListStatus,
    // getSummaryListTotal(state) {
    //     return{
    //         totalQuantity: state.summaryList.reduce((result, el) => { return result + el.Quantity }, 0),
    //         totalBrutoGas: state.summaryList.reduce((result, el) => { return result + el.BrutoGas }, 0),
    //         totalBrutoGasAndBottleWeight: state.summaryList.reduce((result, el) => { return result + el.BrutoGas + el.Quantity * el.BottleWeight }, 0),
    //     }
    // }
};

const actions = {
    [SUMMARYLIST_REQUEST]: ({ commit, dispatch }) => {
        commit(SUMMARYLIST_REQUEST);
        var tripLineId = null;

        if (store.state.ordersList.ordersList.length > 0)
            tripLineId = store.state.ordersList.ordersList[0].TripLineId;

        var filter = [
            {
                Filters: [
                    {
                        name: 'TripLineId',
                        value: tripLineId,
                        operator: '='
                    }
                ]
            }
        ];

        SUMMARYLIST_params.filter = JSON.stringify(filter);

        apiCalls.apiCall({ url: "get", method: "GET", params: SUMMARYLIST_params })
            .then(resp => {
                commit(SUMMARYLIST_SUCCESS, resp.data);            
            })
            .catch(() => {
                commit(SUMMARYLIST_ERROR);
            });
    }
};

const mutations = {
    [SUMMARYLIST_REQUEST]: state => {
        state.summaryListStatus = "loading";
    },
    [SUMMARYLIST_SUCCESS]: (state, resp) => {
        state.summaryListStatus = "success";
        state.summaryList = resp.data;
        Vue.set(state, "summaryList", resp.data);
    },
    [SUMMARYLIST_ERROR]: state => {
        state.summaryListStatus = "error";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};